<template>
  <div class="hot-ranking">
    <div class="row hot-ranking-item" v-for="(item, index) in data" :key="index">
      <div class="row">
        <div class="hot-ranking-item-index" :class="{'hot-ranking-item-top-index': index===0 || index===1 || index===2}">{{index+1}}</div>
        <div>
          <router-link class="hot-ranking-item-title" target="_blank" :to="{path: '/result', query:{q: item.company}}">
            <div>{{item.stock_code}}</div>
          </router-link>
          <div 
            class="hot-ranking-item-content"
            v-for="(it, idx) in item.events" 
            :key="idx"
          >
            <router-link class="hot-ranking-item-content-a" target="_blank" :to="{path: '/event-detail', query:{title: it.title, id: it.id}}">
              <span>{{it.title}}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="hot-ranking-item-count" :class="{'hot-ranking-item-count-positive': item.sentiment==='正面' || sentiment==='正面', 'hot-ranking-item-count-negative': item.sentiment==='负面' || sentiment==='负面'}">{{item.heat}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    sentiment: {
      type: String
    }
  },
  methods: {
    toEventDetailPage(title, id) {
      const routeUrl = this.$router.resolve({
        path: '/event-detail', 
        query: {
          title,
          id
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.hot-ranking {
  padding: 6px 24px;
  &-item {
    padding: 10px 0;
    justify-content: space-between;
    &-index {
      flex-shrink: 0;
      width: 25px;
      height: 100%;
      color: #747990;
      font-size: 14px;
    }
    &-top-index {
      color: #ff5b65;
    }
    &-title {
      margin-bottom: 4px;
      color: #171f46;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &-content-a {
      color: #747990;
      font-size: 12px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &-count {
      margin-left: 10px;
      color: #464d6c;
      font-size: 14px;
    }
    &-count-positive {
      color: #ff5b65;
    }
    &-count-negative {
      color: #36c292;
    }
    &-count::after {
      content: "\00b0";
    }
  }
}
</style>
